<div class="device-summary-container">
  <!-- Header section with navigation and actions -->
  <div class="device-summary-header flex justify-between items-center py-3 px-5">
    <div class="back-button-container flex items-center">
      <button class="btn-blue" (click)="goBackToDeviceSearch()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Device Search</span>
      </button>
    </div>

    <div class="right-section flex items-center gap-4">
      <!-- EDUS-2699: export this device's complete audit-change history -->
      <button
        class="btn-blue"
        [disabled]="!deviceId"
        (click)="exportAuditHistory()"
      >
        <mat-icon>file_download</mat-icon>
        <span>Export Audit History</span>
      </button>

      <!-- TODO: Single device refresh workflow-based bulk refresh -->
      <!-- <div class="refresh-button-container flex items-center">
        <button class="btn-refresh" (click)="refreshDeviceCache()">
          <mat-icon>sync</mat-icon>
          <span>Refresh cache for this device</span>
        </button>
      </div> -->
    </div>
  </div>

  <!-- Loading and error states -->
  <div *ngIf="loading" class="flex justify-center items-center py-10">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div *ngIf="error" class="flex justify-center items-center py-10 text-red-500">
    <mat-icon class="mr-2">error</mat-icon>
    <span>{{ error }}</span>
  </div>

  <ng-container *ngIf="!loading && !error">
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      fxFlexFill
      [(selectedIndex)]="selectedIndex"
      (selectedIndexChange)="onTabChange($event)"
    >
      <mat-tab label="Device Information">
        <div class="tab-content p-5">
          <device-information
            [deviceId]="deviceId"
            [deviceData]="deviceData"
            (deviceUpdated)="loadDeviceData()">
          </device-information>
        </div>
      </mat-tab>

      <mat-tab label="Device Usage">
        <div class="tab-content p-5">
          <device-usage [deviceId]="deviceId" [deviceData]="deviceData"></device-usage>
        </div>
      </mat-tab>

      <mat-tab label="Gopher Buddy Sessions">
        <div class="tab-content">
          <gopher-buddy-sessions [deviceId]="deviceId"></gopher-buddy-sessions>
        </div>
      </mat-tab>

      <mat-tab label="Chrome Audit Events">
        <div class="tab-content">
          <chrome-audit-events [deviceId]="deviceId"></chrome-audit-events>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
